import styles from './fit-toast.css';
import { property, customElement } from 'lit/decorators';
import { LitElement, html } from 'lit';
import { of } from 'rxjs';
import { delay, take, tap } from 'rxjs/operators';

/**
 * @cssprop --fit-toast-bottom
 * @cssprop --fit-toast-display
 * @cssprop --fit-toast-left
 * @cssprop --fit-toast-max-width
 * @cssprop --fit-toast-opacity
 * @cssprop --fit-toast-padding
 * @cssprop --fit-toast-position
 * @cssprop --fit-toast-right
 * @cssprop --fit-toast-transform
 * @cssprop --fit-toast-transition
 * @cssprop --fit-toast-visible-opacity
 * @cssprop --fit-toast-visible-transform
 * @cssprop --fit-toast-width
 * @cssprop --fit-toast-z-index
 */
@customElement('fit-toast')
class FitToast extends LitElement {

  @property({type: Boolean, reflect: true}) opened = false;

  @property({type: Number}) duration = 3000;

  @property({type: String, reflect: true, attribute: 'horizontal-align'}) horizontalAlign = 'right';

  static get styles() {
    return styles
  }

  render() {
    return html`
      <slot></slot>
    `;
  }

  updated(changedProperties) {
    super.updated(changedProperties);
    if (changedProperties.has('opened') && undefined !== changedProperties.get('opened')) {
      this._openedChanged(this.opened);
    }
  }

  open() {
    this.opened = true;
  }

  _openedChanged(opened) {
    if (opened) {
      this.removeAttribute('aria-hidden');
      if (this.duration > 0) {
        of(true).pipe(
          delay(this.duration),
          take(1),
          tap(() => this.opened = false)
        ).subscribe();
      }
    } else {
      this.addEventListener('transitionend', this._afterHide);
    }
  }

  _afterHide() {
    this.removeEventListener('transitionend', this._afterHide);
    this.setAttribute('aria-hidden', 'true');
    this.dispatchEvent(new CustomEvent('fit-toast-closed', {bubbles: true, composed: false}));
  }
}

